import { render, staticRenderFns } from "./CompeteDetail.vue?vue&type=template&id=48e9b920&scoped=true&"
import script from "./CompeteDetail.vue?vue&type=script&lang=js&"
export * from "./CompeteDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompeteDetail.vue?vue&type=style&index=0&id=48e9b920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e9b920",
  null
  
)

export default component.exports